@if (referenceChips.length) {
<div class="reference-chips-wrapper">
  <span class="label">{{ label }}</span>
  <mat-chip-listbox>
    @for (chip of referenceChips; track chip) {
    <mat-chip>
      <span class="chip-text">{{ chip }}</span>
    </mat-chip>
    }
  </mat-chip-listbox>
</div>
}
